import { BaseHttpService } from './base-http-service'
import { Product } from '@/types/product'

class ProductService extends BaseHttpService {
    async getProduct(product_id: Number) {
        const result = await this.doApiGet<Product>(`/product/${product_id}`)
        return result?.response
    }

    async getProductId(slug: string) {
        const result = await this.doApiGet<string>(`/product/id/${slug}`)
        return result?.response
    }

    async clearProductCache(productId: string) {
        const result = await this.doApiPut<string>(`/product/${productId}/clearcache`)
        return result
    }
}

export default function useProductService() {
    return new ProductService()
}
